import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {IntegrationProperties} from './integrationProperties.js';
import {IntegrationGuideDialog} from './integrationGuideDialog.js';
import {isTransformChainOption} from '../../utils/transformChainUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';

export var IntegrationAddEdit = {
	
	addEditIntegration(record, options) {

		var promptInitialTransmission = function() {
			var promptWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: options.admin ? 'Pick Template Or Transmission Type' : 'Pick Template',
				icon: 'vaadin:edit',
				width: 700,
				height: 265,
				listeners: {
					ready: function () {
						promptWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-combo-box',
											itemId: 'template',
											label: 'Template',
											'class': (options.templateMode ? 'hide' : ''),
											name: 'configId',
											colspan: 2,
											'item-value-path': 'configId',
											'item-label-path': 'nameWithModule',
											postinit: function (combo) {
												Promise.all([
													DataManagementService.getIntegrationService().getIntegrations({
														status: 'T'
													}),
													DataManagementService.getIntegrationService().getAvailableModules()
												]).then(function (results) {
													var templates = results[0];
													var availableModules = results[1] || [];
													var availableModuleCodes = {};
													availableModules.forEach(function(module) {
														availableModuleCodes[module.code] = true;
													});
													var filtered = [];
													templates.data.forEach(function (template) {
														if (!options.admin && template.applicationModule
																&& !availableModuleCodes[template.applicationModule]) {
															return;
														}
														var moduleName = template.applicationModuleDescription || template.applicationModule;
														template.nameWithModule = template.name + (moduleName ? ' (' + moduleName + ')' : '');
														filtered.push(template);
													});
													combo.items = filtered;
												});
											},
											listeners: {
												change: function() {
													var configId = ElementUtil.query(formPanel, 'template').value;
													if (configId) {
														ElementUtil.query(formPanel, 'transType').disabled = true;
														ElementUtil.query(formPanel, 'module').disabled = true;
													} else {
														ElementUtil.query(formPanel, 'transType').disabled = false;
														ElementUtil.query(formPanel, 'module').disabled = false;
													}
												}
											}
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'text-align: center;',
											'class': (options.templateMode ? 'hide' : '') + (options.admin ? '' : ' hide'),
											trustedInnerHTML: true,
											innerHTML: '<b> - OR - </b>'
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'transType',
											label: 'Transmission Type',
											name: 'transmissionType',
											'class': (options.admin ? '' : ' hide'),
											'item-value-path': 'transmissionType',
											'item-label-path': 'transmissionDescription',
											placeHolder: 'Select',
											postinit: function (combo) {
												combo.items = options.transmissionTypes.slice(0);
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'module',
											label: 'Module',
											name: 'applicationModule',
											'class': (options.admin ? '' : ' hide'),
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												DataManagementService.getIntegrationService().getAvailableModules().then(function(data) {
													combo.items = data;
												});												
											},
											placeHolder: 'Select'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Proceed')
													],
													listeners: {
														click: function () {

															var data = formPanel.getData();
															if  (data.configId) {
																var template = ElementUtil.query(formPanel, 'template').selectedItem;
																actionShowForm({
																	transmissionType: template.transmissionType,
																	applicationModule: template.applicationModule,
																	template: template,
																	templateId: template.configId,
																	usingTemplate: true
																});
																promptWin.close();
															} else if (data.transmissionType && data.applicationModule) {
																actionShowForm({
																	transmissionType: data.transmissionType,
																	applicationModule: data.applicationModule
																});
																promptWin.close();
															} else {
																window.DL.MessageUtil.showOkMessage('Select Template or Transmission and Module.');
															}															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															promptWin.close();
														}
													}
												}
											]
										}
									]
								}								
							]
						});
						promptWin.addToContentElement(formPanel);
						
					}
				}
			});			
		};
		
		var moduleDefaultHandlers = {};

		var loadModuleDefaultHandlers = function(applicationModule) {
			if (!applicationModule) {
				moduleDefaultHandlers = {};
				return Promise.resolve();
			}
			return DataManagementService.getIntegrationService()
				.getModuleDataHandlers(applicationModule)
				.then(function(handlers) {
					moduleDefaultHandlers = {};
					(handlers || []).forEach(function(handler) {
						moduleDefaultHandlers[handler.dataType] = handler.defaultDataHandler;
					});
				})
				.catch(function() {
					moduleDefaultHandlers = {};
				});
		};

		var actionShowForm = function(initalState) {
			loadModuleDefaultHandlers(initalState.applicationModule).finally(function() {
				actionShowFormInternal(initalState);
			});
		};

		var actionShowFormInternal = function(initalState) {
			
			var fullTransmissionType = options.findTransmission(initalState.transmissionType);
			if (!fullTransmissionType) {
				var transmissionLabel = initalState.transmissionType || '(missing)';
				window.DL.MessageUtil.showOkMessage(
					'Unable to edit this integration. Transmission type "' + transmissionLabel
					+ '" could not be loaded. Refresh the page and try again. '
					+ 'If it still fails, the integration plugin may not be installed/running.'
				);
				return;
			}
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: (record ? 'Edit Integration' : 'Add Integration') + ' - ' + (fullTransmissionType.transmissionDescription || initalState.transmissionType),
				icon: 'vaadin:edit',
				width: .90,
				height: .90,
				listeners: {
					ready: function () {
						addEditWin.show();

						if (options.admin) {
							var placeConfigurationGuideButton = function () {
								if (ElementUtil.query(addEditWin, 'integrationGuideButton')) {
									return;
								}
								var guideHeaderButton = ElementUtil.create({
									tag: 'vaadin-button',
									itemId: 'integrationGuideButton',
									theme: 'primary',
									style: 'margin-top: 4px; margin-right: 8px; margin-left: 25px;',
									children: [
										ElementUtil.makeIcon('vaadin:book', ' Configuration Guide')
									],
									listeners: {
										click: function () {
											var transType = initalState.transmissionType;
											if (!transType) {
												window.DL.MessageUtil.showOkMessage('Select a transmission type first.');
												return;
											}
											IntegrationGuideDialog.show({
												transmissionType: transType,
												transmissionTypes: options.transmissionTypes
											});
										}
									}
								});
								if (addEditWin.headerNode && addEditWin.headerNode.lastElementChild) {
									addEditWin.headerNode.insertBefore(
											guideHeaderButton,
											addEditWin.headerNode.lastElementChild);
								}
							};
							setTimeout(placeConfigurationGuideButton, 0);
						}

						var generateProperties = function(propertyDefinitions, prefix) {
							var prefix = prefix || 'prop';
							var requiredFields = [];
							var optionalFields = [];
							var allFields = [];
							if (!propertyDefinitions) {
								return allFields;
							}
							
							propertyDefinitions.forEach(function(definition){
								var field = {};
								if (definition.dataType === 'String' && isTransformChainOption(definition.optionName)) {
									field.tag = 'dl-transform-chain-field';
									field.autocomplete = 'off';
									if (definition.defaultValueString) {
										field.value = definition.defaultValueString;
									}
								} else if (definition.dataType === 'String') {
									field.tag = 'vaadin-text-field';
									field.autocomplete = 'off';
									if (definition.defaultValueString) {
										field.value = definition.defaultValueString;
									}									
								} else if (definition.dataType === 'PASSWORD') {
									field.tag = 'vaadin-password-field';
									field.autocomplete = 'new-password';
									if (definition.defaultValueString) {
										field.value = definition.defaultValueString;
									}
								} else if (definition.dataType === 'Boolean') {
									field.tag = 'vaadin-checkbox';
									if (definition.defaultValueBoolean) {
										field.checked = definition.defaultValueBoolean;
									}
								} else if (definition.dataType === 'BigDecimal') {
									field.tag = 'vaadin-number-field';
								} else if (definition.dataType === 'Integer') {	
									field.tag = 'vaadin-number-field';
								} else if (definition.dataType === 'Date') {		
									field.tag = 'vaadin-date-time-picker';
									field.step = 1;
									field['helper-text'] = '(mm/dd/yyyy hh:mm:ss)';
									if (definition.defaultValueDate) {
										field.value = TimeUtil.formatDateForDateTimeLoad(TimeUtil.parseDate(definition.defaultValueDate));
									}
								} else if (definition.dataType === 'List') {
									field.tag = 'vaadin-combo-box';
									field.postinit = function (combo) {
										combo.items = definition.lookups;	
									};
								} else {
									field.tag = 'vaadin-text-field';
									if (definition.defaultValueString) {
										field.value = definition.defaultValueString;
									}
								}
								if (definition.required && !options.templateMode) {
									field.required = true;
								}
								field.name = prefix + '-' + definition.optionName;
								field.itemId = prefix + '-' + definition.optionName;
								field.label = definition.description;

								if (definition.helpText) {
									field['helper-text'] = definition.helpText;
								}
								
								if (definition.required && options.templateMode) {
									field['helper-text'] = field['helper-text']
											? field['helper-text'] + ' (Required on Config)'
											: 'Required on Config';
								}
								
								var add = true;
								if (definition.adminConfig && !options.admin) {
									add = false;
								}
								
								if (add) {
									var fieldToAdd = field;
									// Custom elements as direct form-layout children break Vaadin responsive layout (see dl-tagfield / tractors).
									if (field.tag === 'dl-transform-chain-field') {
										fieldToAdd = {
											tag: 'div',
											children: [field]
										};
									}
									if (field.required) {
										requiredFields.push(fieldToAdd);
									} else {
										optionalFields.push(fieldToAdd);
									}
								}
								
							});					
							
							requiredFields.forEach(function(item){
								allFields.push(item);
							});
							
							if (optionalFields.length > 0) {								
								allFields.push({
									tag: 'vaadin-details',
									colspan: 2,									
									children: [
										{
											tag: 'div',
											itemId: 'optionsSection-' + prefix,
											slot: 'summary',
											'class': 'hover-pointer',
											innerHTML: '+ Optional'
										},
										{
											tag: 'vaadin-form-layout',
											children: optionalFields
										}										
									],
									listeners: {
										'opened-changed': function(event) {
											//var optionsSection = ElementUtil.query(formPanel, 'optionsSection-' + fieldCount);
											var optionsSummary = event.target.firstChild;
											if (optionsSummary) {
												if (event.detail.value) {
													optionsSummary.innerHTML = '- Optional';													
												} else {
													optionsSummary.innerHTML = '+ Optional';
													
												}
											}
										}
									}
								});
							}
							
							return allFields;
						};

						var resolveDataFormatHandlerType = function(dataTypeDefinition, applicationModule) {
							if (!dataTypeDefinition) {
								return null;
							}
							if (moduleDefaultHandlers[dataTypeDefinition.dataType]) {
								return moduleDefaultHandlers[dataTypeDefinition.dataType];
							}
							if (dataTypeDefinition.moduleDataFormatHandlerTypes
									&& dataTypeDefinition.moduleDataFormatHandlerTypes[applicationModule]) {
								return dataTypeDefinition.moduleDataFormatHandlerTypes[applicationModule];
							}
							return dataTypeDefinition.dataFormatHandlerType;
						};

						var resolveDataTypeDefinition = function(dataType) {
							var definition = null;
							fullTransmissionType.availableFiles.forEach(function(type) {
								if (type.dataType === dataType) {
									definition = type;
								}
							});
							return definition;
						};

						var isPropertyValueMissing = function(value) {
							if (value === null || value === undefined) {
								return true;
							}
							if (typeof value === 'boolean') {
								return false;
							}
							if (typeof value === 'number') {
								return false;
							}
							return String(value).trim() === '';
						};

						var validateFileConfigurations = function(configFiles, applicationModule) {
							if (options.templateMode) {
								return Promise.resolve({ valid: true, messages: [] });
							}

							var dataTypes = [];
							configFiles.forEach(function(file) {
								if (dataTypes.indexOf(file.dataType) < 0) {
									dataTypes.push(file.dataType);
								}
							});

							var propertyDefinitionsByDataType = {};
							var fetchPromises = dataTypes.map(function(dataType) {
								return DataManagementService.getIntegrationService()
									.getDataPropertyDefinitions(applicationModule, dataType)
									.then(function(results) {
										propertyDefinitionsByDataType[dataType] = results;
									});
							});

							return Promise.all(fetchPromises).then(function() {
								var messages = [];

								configFiles.forEach(function(file) {
									var dataTypeDefinition = resolveDataTypeDefinition(file.dataType);
									var dataTypeLabel = StringUtil.constantToWord(file.dataType);

									if (dataTypeDefinition && dataTypeDefinition.properties) {
										dataTypeDefinition.properties.forEach(function(property) {
											if (property.required) {
												var fileProperties = file.properties || {};
												if (isPropertyValueMissing(fileProperties[property.optionName])) {
													messages.push(dataTypeLabel + ' — ' + property.description);
												}
											}
										});
									}

									var processingDefinitions = propertyDefinitionsByDataType[file.dataType] || [];
									processingDefinitions.forEach(function(property) {
										if (property.required) {
											var dataProperties = file.dataProperties || {};
											if (isPropertyValueMissing(dataProperties[property.code])) {
												messages.push(dataTypeLabel + ' — ' + property.description);
											}
										}
									});

									var resolvedHandler = dataTypeDefinition
										? resolveDataFormatHandlerType(dataTypeDefinition, applicationModule)
										: null;
									if (isPropertyValueMissing(file.dataFormatId) && isPropertyValueMissing(resolvedHandler)) {
										messages.push(dataTypeLabel + ' — Data Format');
									}
								});

								return {
									valid: messages.length === 0,
									messages: messages
								};
							});
						};

						var submitIntegrationForm = function() {
							formPanel.submitForm({
								preSubmit: function (data) {

									var saveModel = {
										config: {
											properties: {}
										}
									};
									saveModel.files = files;
									saveModel.config.applicationModule = initalState.applicationModule;
									saveModel.config.transmissionType = initalState.transmissionType;
									saveModel.config.systemFeed = false;
									if (record && record.templateId) {
										saveModel.config.templateId = record.templateId;
									} else if (initalState.templateId) {
										saveModel.config.templateId = initalState.templateId;
									}

									var scheduleTypeItem = ElementUtil.query(formPanel, 'scheduleType').selectedItem;
									if (scheduleTypeItem.minutes) {
										saveModel.config.intervalMinutes = scheduleTypeItem.minutes;
									} else if (scheduleTypeItem.code === 'Minutes') {
										saveModel.config.intervalMinutes = data.minutes;
									} else {
										saveModel.config.cronExpression = data.cron;
									}

									for (var key in data) {
										if (key.startsWith('prop')) {
											var propKey = key.replace('prop-', '');
											if (data[key] && data[key] !== '') {
												saveModel.config.properties[propKey] = data[key];
											}
										} else {
											saveModel.config[key] = data[key];
										}
									}

									if (formPanel.templateProperties) {
										for (var templatePropKey in formPanel.templateProperties) {
											if (!saveModel.config.properties[templatePropKey] && formPanel.templateProperties[templatePropKey]) {
												saveModel.config.properties[templatePropKey] = formPanel.templateProperties[templatePropKey];
											}
										}
									}

									return saveModel;
								},
								actualCall: function (data) {
									if (record) {
										data.config.configId = record.configId;
									}
									return DataManagementService.getIntegrationService().saveIntegration(data, (record ? true : false), options.templateMode);
								},
								success: function (data, responseData) {
									window.DL.MessageUtil.showToast('Success', 'Saved Integration', {
										theme: 'success',
										position: 'top-stretch'
									});

									if (options.successCallback) {
										options.successCallback();
									}
									addEditWin.close();
								}
							});
						};

						var files = [];
						var EFS_CARRIER_ID_KEY = 'EFS_CARRIER_ID';

						var isSecureFuelModule = function() {
							return initalState.applicationModule === 'SECURE_FUEL';
						};

						var shouldPopulateEfsCarrierId = function() {
							return isSecureFuelModule() && !options.templateMode;
						};

						var extractCompanyCarrierId = function(companyFull) {
							if (companyFull && companyFull.company && companyFull.company.carrierId) {
								return companyFull.company.carrierId;
							}
							return null;
						};

						// User: GET /api/resource/companies/current via getCurrentCompany()
						//       (no @PreAuthorize; swagger mentions COMPANY_MANAGEMENT READ)
						// Admin: GET /api/resource/companies/{companyId} via getCompany()
						//        Requires ADMIN_COMPANY_MANAGEMENT READ
						var fetchIntegrationCompany = function() {
							if (options.admin) {
								var companyIdField = ElementUtil.query(formPanel, 'companyIdField');
								var selectedCompanyId = companyIdField ? companyIdField.value : null;
								if (!selectedCompanyId) {
									return Promise.resolve(null);
								}
								return Service.getCompanyService().getCompany(selectedCompanyId);
							}
							return Service.getCompanyService().getCurrentCompany();
						};

						var setEfsCarrierIdField = function(container, itemId, carrierId) {
							var field = ElementUtil.query(container, itemId);
							if (field) {
								field.value = carrierId;
							}
						};

						var applyEfsCarrierIdToFiles = function(carrierId) {
							files.forEach(function(file) {
								if (!file.dataProperties) {
									file.dataProperties = {};
								}
								file.dataProperties[EFS_CARRIER_ID_KEY] = carrierId;
							});
						};

						var populateEfsCarrierIdFromCompany = function(fileFormPanel, updateFiles) {
							if (!shouldPopulateEfsCarrierId()) {
								return;
							}
							fetchIntegrationCompany().then(function(companyFull) {
								var carrierId = extractCompanyCarrierId(companyFull);
								if (!carrierId) {
									return;
								}
								setEfsCarrierIdField(formPanel, 'prop-' + EFS_CARRIER_ID_KEY, carrierId);
								if (fileFormPanel) {
									setEfsCarrierIdField(fileFormPanel, 'processprop-' + EFS_CARRIER_ID_KEY, carrierId);
								}
								if (updateFiles) {
									applyEfsCarrierIdToFiles(carrierId);
									if (typeof actionRefreshFiles === 'function') {
										actionRefreshFiles();
									}
								}
							}).catch(function(error) {
								console.error(error);
							});
						};

						var fileGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'dataType',
									header: 'Data Type',
									width: '7em'
								},
								{
									path: 'dataFormatId',
									header: 'Data Format',
									width: '7em'
								},								
								{
									path: 'fileName',
									header: 'File Name',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.fileName) {
											root.innerHTML = rowData.item.fileName;
										} else {
											root.innerHTML = '(Default)';
										}
									}
								},
								{
									path: 'priority',
									header: 'Priority',
									width: '7em'
								},																
								{
									path: 'properties',
									header: 'Handling Properties',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.properties) {
											var propsOutput = '';
											for (var key in rowData.item.properties) {
												propsOutput += '<b>' + key + '</b>: ' + rowData.item.properties[key] + '<br>';
											}
											root.innerHTML = propsOutput;
										} else {
											root.innerHTML = 'None';
										}
									}
								},
								{
									path: 'dataProperties',
									header: 'Process Properties',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.dataProperties) {
											var propsOutput = '';
											for (var key in rowData.item.dataProperties) {
												propsOutput += '<b>' + key + '</b>: ' + rowData.item.dataProperties[key] + '<br>';
											}
											root.innerHTML = propsOutput;
										} else {
											root.innerHTML = 'None';
										}
									}
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									fileGrid.selectedItems = item ? [item] : [];
									if (fileGrid.selectedItems.length > 0) {
										ElementUtil.query(formPanel, 'editFile').disabled = false;
										ElementUtil.query(formPanel, 'removeFile').disabled = false;
									} else {
										ElementUtil.query(formPanel, 'editFile').disabled = true;
										ElementUtil.query(formPanel, 'removeFile').disabled = true;
									}
								}
							}
						});
						
						var transmissionProperties = generateProperties(fullTransmissionType.properties);

						var updateScheduleIntervalFields;

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',									
									children: [
										{
											tag: 'vaadin-combo-box',
											itemId: 'companyIdField',
											name: 'companyId',
											style: (options.admin ? '' : 'display: none;'),
											'class': (options.templateMode ? 'hide' : ''),
											label: 'Company',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: options.companyId,
											postinit: function (combo) {
												if (options.admin) {
													Service.getCompanyService().getCompaniesLookup().then(function (data) {
														combo.items = data;
													});
												}
												
												if (options.admin && !options.templateMode) {
													combo.required = true;
												}
											},
											placeHolder: 'Select',
											listeners: {
												change: function() {
													if (options.admin) {
														var selectedCompany = ElementUtil.query(formPanel, 'companyIdField').value;																										
														if (selectedCompany) {
															ElementUtil.query(formPanel, 'addFile').disabled = false;															
														} else {
															ElementUtil.query(formPanel, 'addFile').disabled = true;															
														}
														if (initalState.usingTemplate || !record) {
															populateEfsCarrierIdFromCompany(null, true);
														}
													}		
												}
											}
										},
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'name',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'scheduleType',
											name: 'scheduleType',
											label: 'Schedule Interval',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'DAY',
											postinit: function (combo) {
												var options = [];
												options.push({code: 'DAY', description: 'Daily', minutes: 1440});
												options.push({code: 'W', description: 'Weekly', minutes: 10080});
												options.push({code: 'M', description: 'Monthly', minutes: 40320});
												options.push({code: 'Minutes', description: 'Custom Interval'});
												options.push({code: 'C', description: 'Complex'});
												combo.items = options;
											},
											listeners: {
												change: function () {
													updateScheduleIntervalFields(this.value);
												}
											}
										},
										{
											tag: 'vaadin-number-field',
											itemid: 'schedule-minutes',
											name: 'minutes',
											label: 'Minutes',
											min: 1,
											max: 99999
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'schedule-cron',
											name: 'cron',
											label: 'Cron Expression',
											tooltip: 'test',
											properties: {
												originalLabel: 'Cron Expression'
											},
											listeners: {
												change: {
													fn: function () {
														var cron = ElementUtil.query(formPanel, 'schedule-cron');

														//validate
														var cronModel = {
															expression: cron.value
														};

														Service.getApplicationService().validateCron(cronModel).then(function (result) {
															if (result.valid) {
																cron.label = cron.label + ' (' + result.description + ')';
																cron.invalid = false;
																cron.errorMessage = '';
															} else {
																cron.errorMessage = 'Cron Expression is Invaild.';
																cron.invalid = true;
																cron.label = cron.originalLabel;
															}
														});

													},
													buffer: 2000
												}
											}
										},
										{
											tag: 'div',
											itemid: 'schedule-cron-help',
											colspan: 2,
											trustedInnerHTML: true,
											innerHTML: '<a href="https://www.freeformatter.com/cron-expression-generator-quartz.html" target="_blank" style="margin-left: 10px;">Cron Expression Help</a>'
										}
									]
								},
								{
									tag: 'vaadin-form-layout',
									itemId: 'propertiesLayout',
									children: [
										{
											tag: 'vaadin-number-field',
											name: 'maxRunTimeOverrideMinutes',
											label: 'Max Runtime Override (Minutes)',
											'helper-text': 'Max time an integration is allowed to run',
											placeHolder: 'Default',
											min: 1,
											max: 99999
										},
										{
											tag: 'vaadin-number-field',
											name: 'dataStalenessToleranceMinutes',
											label: 'Data Staleness Tolerance (Minutes)',
											'helper-text': 'Suspend if data pulled is older than tolerance',
											placeHolder: 'Default',
											min: 1,
											max: 99999
										},
										{
											tag: 'dl-section-title',
											title: 'Transmission Properties',
											colspan: 2,
											style: 'margin-top: 20px;'
										},	
										transmissionProperties,
										{
											tag: 'dl-section-title',
											title: 'Data To Pull',
											colspan: 2,
											style: 'margin-top: 20px;'
										},
										{
											tag: 'div',
											style: 'height: 250px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [
																{
																	tag: 'vaadin-button',
																	itemId: 'addFile',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',																	
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function () {
																			actionAddFile();
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'editFile',
																	'class': 'spacer-toolbar-item',
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function () {
																			actionAddFile(fileGrid.selectedItems[0]);
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeFile',
																	theme: 'error primary',
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',
																	disabled: true,
																	children: [
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function () {
																			actionRemoveFile(fileGrid.selectedItems[0]);
																		}
																	}
																}
															]
														},
														fileGrid
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															//must have at least 1 data feed
															if (files.length === 0) {
																window.DL.MessageUtil.showOkMessage('Must have at least 1 data feed defined');
															} else {
																validateFileConfigurations(files, initalState.applicationModule).then(function(result) {
																	if (!result.valid) {
																		window.DL.MessageUtil.showOkMessage(
																			'Required file configuration properties are missing:\n\n' +
																			result.messages.join('\n') +
																			'\n\nUse Edit on each file to complete required fields before saving.'
																		);
																		return;
																	}
																	submitIntegrationForm();
																});
															}

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);

						updateScheduleIntervalFields = function (scheduleTypeValue) {
							ElementUtil.query(formPanel, 'schedule-minutes').classList.add('hide');
							ElementUtil.query(formPanel, 'schedule-cron').classList.add('hide');
							ElementUtil.query(formPanel, 'schedule-cron-help').classList.add('hide');
							if (scheduleTypeValue === 'Minutes') {
								ElementUtil.query(formPanel, 'schedule-minutes').classList.remove('hide');
							}
							if (scheduleTypeValue === 'C') {
								ElementUtil.query(formPanel, 'schedule-cron').classList.remove('hide');
								ElementUtil.query(formPanel, 'schedule-cron-help').classList.remove('hide');
							}
						};
						
						if (options.templateMode) {
							ElementUtil.query(formPanel, 'addFile').disabled = false;
						}
						
						if (!options.admin) {
							ElementUtil.query(formPanel, 'addFile').disabled = false;
						}

						if (!record && !initalState.template) {
							populateEfsCarrierIdFromCompany(null, false);
						}						

						setTimeout(function() {
							updateScheduleIntervalFields(ElementUtil.query(formPanel, 'scheduleType').value);
						}, 250);


						var actionRefreshFiles = function() {
							fileGrid.activeItem = null;
							fileGrid.items = files.slice(0);
						};

						var actionAddFile = function(existingFile) {
							
							//If admin then we need the company selected first
							var selectedCompanyId;
							if (options.admin) {
								var companyIdField = ElementUtil.query(formPanel, 'companyIdField');
								selectedCompanyId = companyIdField.value;
								if (!selectedCompanyId) {
									window.DL.MessageUtil.showToast('Validation', 'Select Company First');
									return;
								}
							}														
							
							var dataType = (existingFile ? existingFile.dataType : null);							
							var dataTypeDefinition;		
							
							if (!dataType && fullTransmissionType.availableFiles.length === 1) {
								dataType = fullTransmissionType.availableFiles[0].dataType;
								dataTypeDefinition = fullTransmissionType.availableFiles[0];
							} else {
								fullTransmissionType.availableFiles.forEach(function(type){
									if (type.dataType === dataType) {
										dataTypeDefinition = type;
									}
								});
							}
							
							var loadDataProperties = function() {	
								var loadMask = window.DL.MessageUtil.fullPageLoadMask('Loading Data Properities...');
								var handlerId = existingFile ? existingFile.dataHandlerId : null;
								DataManagementService.getIntegrationService().getDataPropertyDefinitions(initalState.applicationModule, dataType, handlerId).then(function(results){												
									loadMask.remove();
									showFileFormWin(results);
								}).catch(function(){
									loadMask.remove();
								});								
							};							
							
							if (!dataType) {
								var promptDataTypeWin = ElementUtil.create({
									tag: 'dl-dialog',
									title: 'Select Data Type',
									icon: 'vaadin:edit',
									width: 400,
									height: 200,
									listeners: {
										ready: function () {
											promptDataTypeWin.show();

											var dataTypePromptformPanel = ElementUtil.create({
												tag: 'dl-form-panel',
												itemid: 'form',
												children: [
													{
														tag: 'vaadin-form-layout',
														children: [															
															{
																tag: 'vaadin-combo-box',
																itemId: 'dataType',
																label: 'Data Type',
																name: 'dataType',
																'item-value-path': 'code',
																'item-label-path': 'description',
																required: true,
																postinit: function (combo) {
																	var items = [];
																	fullTransmissionType.availableFiles.forEach(function(item){
																		items.push({
																			code: item.dataType,
																			description: StringUtil.constantToWord(item.dataType),
																			fullType: item
																		});
																	});
																	items.sort(function(a, b){
																		return a.description.localeCompare(b.description);
																	});
																	combo.items = items;
																}
															},															
															{
																tag: 'hr',
																colspan: 2
															},
															{
																tag: 'div',
																style: 'text-align: center;',
																colspan: 2,
																defaults: {
																	tag: 'vaadin-button'
																},
																children: [
																	{
																		theme: 'primary',
																		children: [
																			ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Proceed')
																		],
																		listeners: {
																			click: function () {

																				if (dataTypePromptformPanel.isValid()) {
																					var data = dataTypePromptformPanel.getData();																					
																					dataType = data.dataType;
																					dataTypeDefinition = ElementUtil.query(dataTypePromptformPanel, 'dataType').selectedItem.fullType;
																					
																					loadDataProperties();
																					promptDataTypeWin.close();
																				}
																				
																			}
																		}
																	},
																	{
																		theme: 'tertiary',
																		innerHTML: 'Cancel',
																		style: 'margin-left: 10px;',
																		listeners: {
																			click: function () {
																				//cancel
																				promptDataTypeWin.close();
																			}
																		}
																	}
																]
															}
														]
													}
												]
											});
											promptDataTypeWin.addToContentElement(dataTypePromptformPanel);

										}
									}
								});
								
							} else {
								loadDataProperties();
							}
														
							var showFileFormWin = function(dataPropDefinitions) {
								var addEditFileWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (existingFile ? 'Edit' : 'Add') + ' Data to Pull',
								icon: 'vaadin:edit',
								width: .75,
								height: .75,
								listeners: {
									ready: function () {
										addEditFileWin.show();
										
										var childFiles = [];
										var childFileGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'workingCompanyId',
													header: 'Child Company',
													width: '7em',
													renderer: function (root, column, rowData) {
														if (rowData.item.workingCompanyId) {
															root.innerHTML = rowData.item.workingCompanyId;
														} else {
															root.innerHTML = '(uses parent company)';
														}
													}
												},
												{
													path: 'applicationModule',
													header: 'Module',
													width: '7em'
												},
												{
													path: 'dataFormatId',
													header: 'Data Format',
													width: '7em'
												},	
												{
													path: 'properties',
													header: 'Handling Properties',
													width: '7em',
													renderer: function (root, column, rowData) {
														if (rowData.item.properties) {
															var propsOutput = '';
															for(var key in rowData.item.properties) {
																propsOutput += '<b>' + key + '</b>: ' + rowData.item.properties[key] + '<br>';
															}
															root.innerHTML = propsOutput;
														} else {
															root.innerHTML = 'None';
														}
													}
												},
												{
													path: 'dataProperties',
													header: 'Process Properties',
													width: '7em',
													renderer: function (root, column, rowData) {
														if (rowData.item.dataProperties) {
															var propsOutput = '';
															for(var key in rowData.item.dataProperties) {
																propsOutput += '<b>' + key + '</b>: ' + rowData.item.dataProperties[key] + '<br>';
															}
															root.innerHTML = propsOutput;
														} else {
															root.innerHTML = 'None';
														}
													}
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													childFileGrid.selectedItems = item ? [item] : [];
													if (childFileGrid.selectedItems.length > 0) {
														ElementUtil.query(fileFormPanel, 'editChildFile').disabled = false;
														ElementUtil.query(fileFormPanel, 'removeChildFile').disabled = false;
													} else {
														ElementUtil.query(fileFormPanel, 'editChildFile').disabled = true;
														ElementUtil.query(fileFormPanel, 'removeChildFile').disabled = true;
													}
												}
											}
										});
										
										var xrefs = [];
										var xrefGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'mappingType',
													header: 'Mapping Type',
													width: '7em'
												},
												{
													path: 'sourceValue',
													header: 'Source Value',
													width: '7em'
												},																				
												{
													path: 'xrefValue',
													header: 'Xref Value',
													width: '7em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													xrefGrid.selectedItems = item ? [item] : [];
													if (xrefGrid.selectedItems.length > 0) {
														ElementUtil.query(fileFormPanel, 'editXref').disabled = false;
														ElementUtil.query(fileFormPanel, 'removeXref').disabled = false;
														ElementUtil.query(fileFormPanel, 'propertiesXref').disabled = false;
													} else {
														ElementUtil.query(fileFormPanel, 'editXref').disabled = true;
														ElementUtil.query(fileFormPanel, 'removeXref').disabled = true;
														ElementUtil.query(fileFormPanel, 'propertiesXref').disabled = true;														
													}
												}
											}
										});
										
										var handlingProperties = generateProperties(dataTypeDefinition.properties);
										
										var convertedProperties = [];
										dataPropDefinitions.forEach(function(item){
											convertedProperties.push({
												description: item.description,												
												dataType: item.fieldType,
												required: item.required,
												optionName: item.code,
												helpText: item.helpText,
												defaultValueDate: item.defaultValueDate,
												defaultValueBoolean: item.defaultValueBoolean,
												defaultValueString: item.defaultValueString,
												defaultValueInt: item.defaultValueInt												
											});											
										});										
										var processingPropertiesPrefix = 'processprop';
										var processingProperties = generateProperties(convertedProperties, processingPropertiesPrefix);
										
										var resolvedDataFormatHandlerType = resolveDataFormatHandlerType(
											dataTypeDefinition,
											initalState.applicationModule
										);

										var fileFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',									
													children: [
														{
															tag: 'vaadin-number-field',
															label: 'Priority',
															name: 'priority',
															required: true,
															value: 0,
															min: -9999,
															max: 9999
														},														
														{
															tag: 'vaadin-text-field',
															label: 'Data Time Zone',
															name: 'inputTimeZone',															
															maxlength: 60
														},
														{
															tag: 'vaadin-combo-box',
															name: 'dataFormatId',
															label: 'Data Format',
															'class': (resolvedDataFormatHandlerType ? 'hide' : ''),													
															'item-value-path': 'handlerId',
															'item-label-path': 'description',															
															postinit: function (combo) {																
																DataManagementService.getIntegrationService().getDataHandlers(initalState.applicationModule, dataType).then(function(handlers){																	
																	combo.items = handlers;
																});			
																
																if (!resolvedDataFormatHandlerType) {
																	combo.required = true;
																}																
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'datafilterId',
															label: 'Data Filter',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'datafilterId',
															'item-label-path': 'name',															
															postinit: function (combo) {																
																DataManagementService.getIntegrationService().getDataFilters(selectedCompanyId).then(function(results){																	
																	combo.items = results;
																});																
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'unitMatchId',
															label: 'Unit Matching Rules',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'unitMatchId',
															'item-label-path': 'name',															
															postinit: function (combo) {																
																DataManagementService.getIntegrationService().getUnitMatchingRules(selectedCompanyId).then(function(results){																	
																	combo.items = results;
																});																
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'autoUnitId',
															label: 'Auto Unit Rules',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'autoUnitId',
															'item-label-path': 'name',
															placeHolder: ImportUtil.autoUnitPlaceholderForDataTypes(dataType),
															clearButtonVisible: true,
															postinit: function (combo) {																
																DataManagementService.getIntegrationService().getAutoUnits(selectedCompanyId).then(function(results){
																	var all = [];
																	(results || []).forEach(function(item){
																		all.push(item);
																	});
																	all.push({
																		autoUnitId: 'NO_AUTO_UNIT',
																		name: 'No Auto Unit Creation'
																	});
																	combo.items = all;
																	if (!existingFile || !existingFile.autoUnitId) {
																		var defaultAutoUnitId = ImportUtil.defaultAutoUnitIdForDataTypes(dataType);
																		if (defaultAutoUnitId) {
																			combo.value = defaultAutoUnitId;
																		}
																	}
																});																
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'autoGroupId',
															label: 'Auto Group Rules',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'autoGroupId',
															'item-label-path': 'name',
															postinit: function (combo) {
																DataManagementService.getIntegrationService().getAutoGroups(selectedCompanyId, dataType).then(function(results){
																	combo.items = results;
																});
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'dataTransformRuleSetId',
															label: 'Data Transform Rule Set',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'dataTransformRuleSetId',
															'item-label-path': 'name',
															postinit: function (combo) {
																DataManagementService.getIntegrationService().getDataTransformRuleSets(selectedCompanyId, dataType).then(function(results){
																	combo.items = results;
																});
															}
														},
														{
															tag: 'vaadin-combo-box',
															name: 'gpsFilterId',
															label: 'GPS Filtering',
															'class': (options.templateMode ? 'hide' : ''),
															'item-value-path': 'gpsFilterId',
															'item-label-path': 'name',															
															placeHolder: 'Default',
															postinit: function (combo) {																
																DataManagementService.getIntegrationService().getGPSFilters(selectedCompanyId).then(function(results){
																	var all = [];
																	results.forEach(function(item){
																		all.push(item);
																	});
																	all.push({
																		gpsFilterId: 'NO_FILTER',
																		name: 'No Filter'
																	});
																	combo.items = all;
																});																
															}
														},
														{
															tag: 'vaadin-text-field',
															label: 'Filename Prefix',
															name: 'fileNamePrefix',															
															maxlength: 5
														}
													]
												},
												{
													tag: 'vaadin-form-layout',
													itemId: 'propertiesLayout',
													children: [	
														{
															tag: 'dl-section-title',
															title: 'Handling Properties',
															colspan: 2,
															style: 'margin-top: 20px;'
														},	
														handlingProperties,
														{
															tag: 'dl-section-title',
															title: 'Processing Properties',
															colspan: 2,
															style: 'margin-top: 20px;'
														},	
														processingProperties,
														{
															tag: 'dl-section-title',
															title: 'Xrefs',
															'class': (dataTypeDefinition.xrefMappingSupported ? '' : 'hide') + (options.templateMode ? ' hide' : ''),
															colspan: 2,
															style: 'margin-top: 20px;'
														},
														{
															tag: 'div',
															style: 'height: 250px;',
															'class': (dataTypeDefinition.xrefMappingSupported ? '' : 'hide') + (options.templateMode ? ' hide' : ''),
															colspan: 2,
															children: [
																{
																	tag: 'dl-flex-layout',
																	children: [
																		{
																			tag: 'dl-toolbar',
																			slot: 'toolbar',
																			theme: 'spacing',
																			children: [
																				{
																					tag: 'vaadin-button',
																					theme: 'primary',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:plus', ' Add')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditXref();
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'editXref',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:edit', ' Edit')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditXref(xrefGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'propertiesXref',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:clipboard-check', ' Properties')
																					],
																					listeners: {
																						click: function () {
																							actionManageProperties(xrefGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'removeXref',
																					theme: 'error primary',
																					'class': 'spacer-toolbar-item',
																					style: 'float: right;',
																					children: [
																						ElementUtil.makeIcon('vaadin:close', ' Remove')
																					],
																					listeners: {
																						click: function () {
																							actionRemoveXref(xrefGrid.selectedItems[0]);
																						}
																					}
																				}
																			]
																		},
																		xrefGrid
																	]
																}
															]
														},
														{
															tag: 'dl-section-title',
															title: 'Child Data Handlers',
															'class': (options.admin ? '' : 'hide') + (options.templateMode ? ' hide' : ''),
															colspan: 2,
															style: 'margin-top: 20px;'
														},
														{
															tag: 'div',
															style: 'height: 250px;',
															'class': (options.admin ? '' : 'hide') + (options.templateMode ? ' hide' : ''),
															colspan: 2,
															children: [
																{
																	tag: 'dl-flex-layout',
																	children: [
																		{
																			tag: 'dl-toolbar',
																			slot: 'toolbar',
																			theme: 'spacing',
																			children: [
																				{
																					tag: 'vaadin-button',
																					theme: 'primary',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:plus', ' Add')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditChildConfig();
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'editChildFile',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:edit', ' Edit')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditChildConfig(childFileGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'removeChildFile',
																					theme: 'error primary',
																					'class': 'spacer-toolbar-item',
																					style: 'float: right;',
																					children: [
																						ElementUtil.makeIcon('vaadin:close', ' Remove')
																					],
																					listeners: {
																						click: function () {
																							actionRemoveChildConfig(childFileGrid.selectedItems[0]);
																						}
																					}
																				}
																			]
																		},
																		childFileGrid
																	]
																}
															]
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		(existingFile ?  ElementUtil.makeIcon('vaadin:arrow-circle-up-o', ' Update') : ElementUtil.makeIcon('vaadin:plus', ' Add'))
																	],
																	listeners: {
																		click: function () {

																			if (fileFormPanel.isValid()){
																				var data = fileFormPanel.getData();
																																								
																				var saveFileModel = {
																					dataType: dataType,
																					properties: {},
																					dataProperties: {}																							
																				};
																				
																				for (var key in data) {
																					if (key.startsWith('prop')) {
																						var propKey = key.replace('prop-', '');
																						if (data[key] && data[key] !== '') {
																							saveFileModel.properties[propKey] = data[key];
																						}
																					} else if (key.startsWith(processingPropertiesPrefix)) {
																						var propKey = key.replace(processingPropertiesPrefix + '-', '');
																						if (data[key] && data[key] !== '') {
																							saveFileModel.dataProperties[propKey] = data[key];
																						}
																					} else {
																						saveFileModel[key] = data[key];
																					}
																				}
																				
																				if (data.dataFormatId && data.dataFormatId !== '') {
																					saveFileModel.dataFormatId = data.dataFormatId;
																				} else {
																					saveFileModel.dataFormatId = resolveDataFormatHandlerType(
																						dataTypeDefinition,
																						initalState.applicationModule
																					);
																				}
																				
																				if (xrefs) {
																					saveFileModel.xrefs = xrefs;
																				}
																				if (childFiles) {
																					saveFileModel.childFiles = childFiles;
																				}																																																										
																				
																				if (existingFile) {
																					for (var key in saveFileModel) {
																						existingFile[key] = saveFileModel[key];
																					}																					
																				} else {
																					saveFileModel.configFileId = ElementUtil.nextId();
																					files.push(saveFileModel);
																				}
																				actionRefreshFiles();
																				addEditFileWin.close();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditFileWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										
										addEditFileWin.addToContentElement(fileFormPanel);
										
										var actionRefreshChildConfigs = function() {
											childFileGrid.activeItem = null;											
											childFileGrid.items = childFiles.slice();
										};
										
										var actionAddEditChildConfig = function(childConfig) {
											
											var loadChildModuleProperties = function(selectedModule) {
												
												var loadMask = window.DL.MessageUtil.fullPageLoadMask();
												DataManagementService.getIntegrationService().getDataPropertyDefinitions(selectedModule, dataType).then(function (results) {
													loadMask.remove();

													var convertedModuleProperties = [];
													results.forEach(function(item) {
														convertedModuleProperties.push({
															description: item.description,
															dataType: item.fieldType,
															required: item.required,
															optionName: item.code,
															helpText: item.helpText,
															defaultValueDate: item.defaultValueDate,
															defaultValueBoolean: item.defaultValueBoolean,
															defaultValueString: item.defaultValueString,
															defaultValueInt: item.defaultValueInt
														});
													});

													showAddEditChildWin(selectedModule, convertedModuleProperties);													
												});

											}; 
											
											if (childConfig) {
												var selectedModule = childConfig.applicationModule;
												loadChildModuleProperties(selectedModule);
											} else {
												//prompt for module											
												//get data properties for type and module
												var promptModuleWin = ElementUtil.create({
														tag: 'dl-dialog',
														title: 'Select Module for Child',
														icon: 'vaadin:edit',
														width: 400,
														height: 200,
														listeners: {
															ready: function () {
																promptModuleWin.show();

																var modulePromptformPanel = ElementUtil.create({
																	tag: 'dl-form-panel',
																	itemid: 'form',
																	children: [
																		{
																			tag: 'vaadin-form-layout',
																			children: [
																				{
																					tag: 'vaadin-combo-box',
																					itemId: 'module',
																					label: 'Module',
																					name: 'applicationModule',
																					'item-value-path': 'code',
																					'item-label-path': 'description',																			
																					postinit: function (combo) {
																						DataManagementService.getIntegrationService().getAvailableModules().then(function (data) {
																							combo.items = data;
																						});																						
																					},
																					placeHolder: 'Select'
																				},
																				{
																					tag: 'hr',
																					colspan: 2
																				},
																				{
																					tag: 'div',
																					style: 'text-align: center;',
																					colspan: 2,
																					defaults: {
																						tag: 'vaadin-button'
																					},
																					children: [
																						{
																							theme: 'primary',
																							children: [
																								ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Proceed')
																							],
																							listeners: {
																								click: function () {

																									if (modulePromptformPanel.isValid()) {
																										var data = modulePromptformPanel.getData();
																										var selectedModule = data.applicationModule;

																										loadChildModuleProperties(selectedModule);
																										promptModuleWin.close();
																										
																									}

																								}
																							}
																						},
																						{
																							theme: 'tertiary',
																							innerHTML: 'Cancel',
																							style: 'margin-left: 10px;',
																							listeners: {
																								click: function () {
																									//cancel
																									promptModuleWin.close();
																								}
																							}
																						}
																					]
																				}
																			]
																		}
																	]
																});
																promptModuleWin.addToContentElement(modulePromptformPanel);

															}
														}
													});
											}										
											
											var showAddEditChildWin = function(module, moduleDataPropertyDefinitions) {
												var addEditChildWin = ElementUtil.create({
													tag: 'dl-dialog',
													title: (childConfig ? 'Edit' : 'Add') + ' Child Data Handler',
													icon: 'vaadin:edit',
													width: .65,
													height: .65,
													listeners: {
														ready: function () {
															addEditChildWin.show();

															var handlingChildProperties = generateProperties(dataTypeDefinition.properties);
															
															var processingChildPropertiesPrefix = 'processprop';
															var processingChildProperties = generateProperties(moduleDataPropertyDefinitions, processingChildPropertiesPrefix);

															var childFormPanel = ElementUtil.create({
																tag: 'dl-form-panel',
																itemid: 'form',
																children: [
																	{
																		tag: 'vaadin-form-layout',									
																		children: [
																			{
																				tag: 'vaadin-combo-box',
																				itemId: 'companyIdField',
																				name: 'workingCompanyId',																			
																				label: 'Working Company',
																				'item-value-path': 'code',
																				'item-label-path': 'description',																			
																				postinit: function (combo) {
																					Service.getCompanyService().getCompaniesLookup().then(function(data) {
																						combo.items = data;
																					});
																				},
																				placeHolder: 'Use Integration Company'
																			},																		
																			{
																				tag: 'vaadin-combo-box',
																				name: 'dataFormatId',
																				label: 'Data Format',																															
																				'item-value-path': 'handlerId',
																				'item-label-path': 'description',
																				required: true,
																				postinit: function (combo) {																
																					DataManagementService.getIntegrationService().getDataHandlers(module, dataType).then(function(handlers){																	
																						combo.items = handlers;
																					});															
																				}
																			},
																			{
																				tag: 'vaadin-text-field',
																				label: 'Data Time Zone',
																				name: 'inputTimeZone',															
																				maxlength: 60
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'datafilterId',
																				label: 'Data Filter',
																				'item-value-path': 'datafilterId',
																				'item-label-path': 'name',															
																				postinit: function (combo) {																
																					DataManagementService.getIntegrationService().getDataFilters(selectedCompanyId).then(function(results){																	
																						combo.items = results;
																					});																
																				}
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'unitMatchId',
																				label: 'Unit Matching Rules',
																				'item-value-path': 'unitMatchId',
																				'item-label-path': 'name',															
																				postinit: function (combo) {																
																					DataManagementService.getIntegrationService().getUnitMatchingRules(selectedCompanyId).then(function(results){																	
																						combo.items = results;
																					});																
																				}
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'autoUnitId',
																				label: 'Auto Unit Rules',
																				'item-value-path': 'autoUnitId',
																				'item-label-path': 'name',
																				placeHolder: ImportUtil.autoUnitPlaceholderForDataTypes(dataType),
																				clearButtonVisible: true,
																				postinit: function (combo) {																
																					DataManagementService.getIntegrationService().getAutoUnits(selectedCompanyId).then(function(results){
																						var all = [];
																						(results || []).forEach(function(item){
																							all.push(item);
																						});
																						all.push({
																							autoUnitId: 'NO_AUTO_UNIT',
																							name: 'No Auto Unit Creation'
																						});
																						combo.items = all;
																						if (!childConfig || !childConfig.autoUnitId) {
																							var defaultAutoUnitId = ImportUtil.defaultAutoUnitIdForDataTypes(dataType);
																							if (defaultAutoUnitId) {
																								combo.value = defaultAutoUnitId;
																							}
																						}
																					});																
																				}
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'autoGroupId',
																				label: 'Auto Group Rules',
																				'item-value-path': 'autoGroupId',
																				'item-label-path': 'name',
																				postinit: function (combo) {
																					DataManagementService.getIntegrationService().getAutoGroups(selectedCompanyId, dataType).then(function(results){
																						combo.items = results;
																					});
																				}
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'dataTransformRuleSetId',
																				label: 'Data Transform Rule Set',
																				'item-value-path': 'dataTransformRuleSetId',
																				'item-label-path': 'name',
																				postinit: function (combo) {
																					DataManagementService.getIntegrationService().getDataTransformRuleSets(selectedCompanyId, dataType).then(function(results){
																						combo.items = results;
																					});
																				}
																			},
																			{
																				tag: 'vaadin-combo-box',
																				name: 'gpsFilterId',
																				label: 'GPS Filtering',
																				'item-value-path': 'gpsFilterId',
																				'item-label-path': 'name',															
																				placeHolder: 'Default',
																				postinit: function (combo) {																
																					DataManagementService.getIntegrationService().getGPSFilters(selectedCompanyId).then(function(results){
																						var all = [];
																						results.forEach(function(item){
																							all.push(item);
																						});
																						all.push({
																							gpsFilterId: 'NO_FILTER',
																							name: 'No Filter'
																						});
																						combo.items = results;
																					});																
																				}
																			}														
																		]
																	},
																	{
																		tag: 'vaadin-form-layout',
																		itemId: 'propertiesLayout',
																		children: [	
																			{
																				tag: 'dl-section-title',
																				title: 'Handling Properties',
																				colspan: 2,
																				style: 'margin-top: 20px;'
																			},	
																			handlingChildProperties,																		
																			{
																				tag: 'dl-section-title',
																				title: 'Processing Properties',
																				colspan: 2,
																				style: 'margin-top: 20px;'
																			},	
																			processingChildProperties,
																			{
																				tag: 'hr',
																				colspan: 2
																			},
																			{
																				tag: 'div',
																				style: 'text-align: center;',
																				colspan: 2,
																				defaults: {
																					tag: 'vaadin-button'
																				},
																				children: [
																					{
																						theme: 'primary',
																						children: [
																							(childConfig ?  ElementUtil.makeIcon('vaadin:arrow-circle-up-o', ' Update') : ElementUtil.makeIcon('vaadin:plus', ' Add'))
																						],
																						listeners: {
																							click: function () {
																								
																								if (childFormPanel.isValid()) {
																									var data = childFormPanel.getData();
																									
																									var childConfigModel = {
																										applicationModule: module,
																										properties: {},
																										dataProperties: {}
																									};
																									for (var key in data) {
																										if (key.startsWith('prop')) {
																											var propKey = key.replace('prop-', '');
																											if (data[key] && data[key] !== '') {
																												childConfigModel.properties[propKey] = data[key];
																											}
																										} else if (key.startsWith(processingChildPropertiesPrefix)) {
																											var propKey = key.replace(processingChildPropertiesPrefix + '-', '');
																											if (data[key] && data[key] !== '') {
																												childConfigModel.dataProperties[propKey] = data[key];
																											}
																										} else {
																											childConfigModel[key] = data[key];
																										}
																									}
																									
																									if (childConfig) {
																										childConfig.dataFormatId = childConfigModel.dataFormatId;
																										childConfig.dataFilterId = childConfigModel.dataFilterId;
																										childConfig.unitMatchId = childConfigModel.unitMatchId;
																										childConfig.autoUnitId = childConfigModel.autoUnitId;
																										childConfig.autoGroupId = childConfigModel.autoGroupId;
																										childConfig.dataTransformRuleSetId = childConfigModel.dataTransformRuleSetId;
																										childConfig.gpsFilterId = childConfigModel.gpsFilterId;
																										childConfig.inputTimeZone = childConfigModel.inputTimeZone;
																										childConfig.workingCompanyId = childConfigModel.workingCompanyId;
																										childConfig.properties = childConfigModel.properties;
																										childConfig.dataProperties = childConfigModel.dataProperties;																										
																									} else {
																										childConfigModel.childFileId = ElementUtil.nextId();																										
																										childFiles.push(childConfigModel);
																									}
																									actionRefreshChildConfigs();
																									addEditChildWin.close();
																								}
																							}
																						}
																					},
																					{
																						theme: 'tertiary',
																						innerHTML: 'Cancel',
																						style: 'margin-left: 10px;',
																						listeners: {
																							click: function () {
																								//cancel
																								addEditChildWin.close();
																							}
																						}
																					}
																				]
																			}
																		]
																	}
																]

															});
															addEditChildWin.addToContentElement(childFormPanel);

															if (childConfig) {

																var loadModel = {
																};
																
																for (var key in childConfig) {
																	if (key === 'properties') {
																		if (childConfig.properties) {
																			for (var propKey in childConfig.properties) {
																				loadModel['prop-' + propKey] = childConfig.properties[propKey]; 
																			}
																		}
																	} else if (key === 'dataProperties') {
																		if (childConfig.dataProperties) {
																			for (var propKey in childConfig.dataProperties) {
																				loadModel[processingChildPropertiesPrefix + '-' + propKey] = childConfig.dataProperties[propKey]; 
																			}
																		}
																	} else {
																		loadModel[key] = childConfig[key];
																	}
																}
																childFormPanel.load(loadModel);

															}

														}
													}
												});
											};
											
										};
										
										var actionRemoveChildConfig = function(childConfig) {
											var newChildFiles = [];
											childFiles.forEach(function(item) {
												if (item.childFileId !== childConfig.childFileId) {
													newChildFiles.push(item);
												}
											});
											childFiles = newChildFiles;
											actionRefreshChildConfigs();
										};
										
										var actionRefreshXrefs = function() {
											xrefGrid.activeItem = null;											
											xrefGrid.items = xrefs.slice();
										};
										
										var actionAddEditXref = function(xref) {
											
											var addEditXrefWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: (xref ? 'Edit' : 'Add') + ' Cross Reference',
												icon: 'vaadin:edit',
												width: 500,
												height: 325,
												listeners: {
													ready: function () {
														addEditXrefWin.show();
														
														var xrefFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															itemid: 'form',
															children: [
																{
																	tag: 'vaadin-form-layout',									
																	children: [
																		{
																			tag: 'vaadin-combo-box',
																			name: 'mappingType',
																			label: 'Mapping Xref',
																			'item-value-path': 'code',
																			'item-label-path': 'description',
																			required: true,
																			postinit: function (combo) {	
																				Service.getLookupService().getLookupValues('IntegrationMappingXrefType').then(function(data){
																					combo.items = data;
																				});																
																			}
																		},
																		{
																			tag: 'vaadin-text-field',
																			label: 'Source Value',
																			name: 'sourceValue',
																			required: true,
																			maxlength: 255
																		},
																		{
																			tag: 'vaadin-text-field',
																			label: 'Xref Value',
																			name: 'xrefValue',															
																			required: true,
																			maxlength: 255
																		},																																
																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						(xref ?  ElementUtil.makeIcon('vaadin:arrow-circle-up-o', ' Update') : ElementUtil.makeIcon('vaadin:plus', ' Add'))
																					],
																					listeners: {
																						click: function () {
																							
																							if (xrefFormPanel.isValid()) {
																								var data = xrefFormPanel.getData();																							
																								if (xref) {
																									xref.mappingType = data.mappingType;
																									xref.xrefValue = data.xrefValue;
																									xref.sourceValue = data.sourceValue;
																								} else {
																									xrefs.push(data);
																								}
																								actionRefreshXrefs();
																								addEditXrefWin.close();
																							}
																							
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function () {																							
																							addEditXrefWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]

														});

														addEditXrefWin.addToContentElement(xrefFormPanel);
														
														if (xref) {
															xrefFormPanel.load(xref);
														}
														
													}
												}
											});
											
										};
										
										var actionRemoveXref = function(xref) {
											var newXrefs = [];
											xrefs.forEach(function(item) {
												if (item.mappingType !== xref.mappingType && 
													item.xrefValue !== xref.xrefValue &&
													item.xrefValue !== xref.xrefValue) {
													newXrefs.push(item);
												}
											});
											xrefs = newXrefs;
											actionRefreshXrefs();
										};
										
										var actionManageProperties = function(xref) {
											IntegrationProperties.xrefProperties(xref);																							
										};
										
										if (existingFile) {
											
											var loadModel = {												
											};
											
											for (var key in existingFile) {
												if (key === 'properties') {
													if (existingFile.properties) {
														for (var propKey in existingFile.properties) {
															loadModel['prop-' + propKey] = existingFile.properties[propKey];
														}
													}
												} else if (key === 'dataProperties') {
													if (existingFile.dataProperties) {
														for (var propKey in existingFile.dataProperties) {
															loadModel[processingPropertiesPrefix + '-' + propKey] = existingFile.dataProperties[propKey];
														}
													}
												} else {
													loadModel[key] = existingFile[key];
												}
											}											
											
											fileFormPanel.load(loadModel);
											
											xrefs = (existingFile.xrefs || []).slice();
											actionRefreshXrefs();
											
											childFiles = (existingFile.childFiles || []).slice();
											actionRefreshChildConfigs();
												
										} else {
											populateEfsCarrierIdFromCompany(fileFormPanel, false);
										}
										
									}
								}
							});
							};
						};

						var actionRemoveFile = function(existingFile) {
							var newItems = [];
							files.forEach(function(item) {
								if (item.configFileId !== existingFile.configFileId) {
									newItems.push(item);
								}
							});
							files = newItems;
							actionRefreshFiles();
						};
						
						if (initalState.template) {							
							var loadMask = addEditWin.showLoading();
							DataManagementService.getIntegrationService().getIntegrationDetail(initalState.template.configId).then(function(fullConfig){
								loadMask.remove();
								var configLoadModel = {								
								};
								
								for (var key in fullConfig.config) {
									if (key.startsWith('properties')) {
										var properties = fullConfig.config[key];
										for (var propkey in properties) {
											var fullKey = 'prop-' + propkey;
											configLoadModel[fullKey] = properties[propkey];
										}																				
									} else {
										configLoadModel[key] = fullConfig.config[key];
									}
								}
								
								var scheduleType = ElementUtil.query(formPanel, 'scheduleType');
								if (fullConfig.config.cronExpression) {
									configLoadModel.cron = fullConfig.config.cronExpression;
									scheduleType.value = 'C';
								} else if (fullConfig.config.intervalMinutes === 1440) {
									configLoadModel.minutes = fullConfig.config.intervalMinutes;
									scheduleType.value = 'DAY';
								} else if (fullConfig.config.intervalMinutes === 10080) {
									configLoadModel.minutes = fullConfig.config.intervalMinutes;
									scheduleType.value = 'W';
								} else if (fullConfig.config.intervalMinutes === 40320) {
									configLoadModel.minutes = fullConfig.config.intervalMinutes;
									scheduleType.value = 'M';
								} else {
									configLoadModel.minutes = fullConfig.config.intervalMinutes;
									scheduleType.value = 'Minutes';
								}					
								
								if (initalState.usingTemplate) {
									configLoadModel.companyId = null;
								}
								
								formPanel.load(configLoadModel);
								updateScheduleIntervalFields(scheduleType.value);
								
								files = fullConfig.files;
								actionRefreshFiles();
								if (initalState.usingTemplate) {
									populateEfsCarrierIdFromCompany(null, true);
								}	
								
								//For some reason this field has a hard time pickup the change
								//this helps pick it up with the focus
								var companyIdField = ElementUtil.query(formPanel, 'companyIdField');
								if (companyIdField) {
									companyIdField.focus();
									companyIdField.blur();
									companyIdField.focus();
									
									const event = new Event('change');
									companyIdField.dispatchEvent(event);
								}

								var hideFilledTemplateProperties = function(propertyMap) {
									var capturedProperties = formPanel.templateProperties || {};
									if (!propertyMap) {
										return capturedProperties;
									}
									for (var propkey in propertyMap) {
										if (!propertyMap[propkey]) {
											continue;
										}
										capturedProperties[propkey] = propertyMap[propkey];
										var propertyField = ElementUtil.query(formPanel, 'prop-' + propkey);
										if (propertyField && !propertyField.required) {
											propertyField.classList.add('hide');
										}
									}
									return capturedProperties;
								};
								
								//hide properties for user that are already filled in
								if (!options.admin) {
									if (record) {
										//on edit use the template properties capture on the add of the user to hide template properties.
										if (fullConfig.template && fullConfig.template.config) {
											formPanel.templateProperties = hideFilledTemplateProperties(fullConfig.template.config.properties);
										}	
									} else {										
										//use template to hide filled in properties
										for (var key in fullConfig.config) {
											if (key.startsWith('properties')) {
												formPanel.templateProperties = hideFilledTemplateProperties(fullConfig.config[key]);
											}
										}
									}
									
									//hide file Add and Remove
									var addFileButton = ElementUtil.query(formPanel, 'addFile');
									if (addFileButton) {
										addFileButton.classList.add('hide');
									}
									var removeFileButton = ElementUtil.query(formPanel, 'removeFile');
									if (removeFileButton) {
										removeFileButton.classList.add('hide');
									}
								}
								
							}).catch(function(error){
								console.error(error);
								window.DL.MessageUtil.showOkMessage('Unable to load template/record.');
								loadMask.remove();
							});
						}

					}
				}
			});

		};
		
		if (!record) {
			promptInitialTransmission();
		} else {
			actionShowForm({
				transmissionType: record.transmissionType,
				applicationModule: record.applicationModule,
				template: record
			});
		}
		
	}
	
};

